import type { ClientSummary } from '../schemas/client';

/**
 * Search over what is on the row.
 *
 * The name and the address, because those are what the operator can see and
 * therefore what they will type. Not the tenant id: it is on the detail screen,
 * and matching a hidden field makes a row appear for a reason the screen does
 * not show.
 *
 * ## What used to be here
 *
 * A `ready` / `needs-owner` / `all` filter, defaulting to `ready`. It was
 * removed with its chips: a default that hides rows makes the list answer a
 * narrower question than the one it appears to answer, and the owner state it
 * sorted on is already a column on every row. Searching narrows only when the
 * operator asks it to, and says so by having text in it.
 */
export function searchClients(clients: readonly ClientSummary[], search: string): ClientSummary[] {
    const needle = search.trim().toLowerCase();
    if (needle.length === 0) return [...clients];

    return clients.filter(
        (client) =>
            client.displayName.toLowerCase().includes(needle) ||
            (client.slug ?? '').toLowerCase().includes(needle),
    );
}
